/// ----------------------------------------------------------------------------------------
///Copyright (C) 2016 to the present, Crestron Electronics, Inc.
///All rights reserved.
///No part of this software may be reproduced in any form, machine
///or natural, without the express written consent of Crestron Electronics.
/// ----------------------------------------------------------------------------------------
/// <file>
/// <name>loggedin-guard.service.ts</name>
///
/// <description>
/// A router guard that checks if the user is logged in. If not, redirect to /login
/// </description>
///
/// <author>Yaron Habot</author>
/// <created>16 Jan 2017</created>
///
/// <changelog>
///   Date  Who Version     Flag Comments
/// ======= === =========== ==== ===========================================================
/// 16Jan17 YH  1.0.0000         First cut
/// </changelog>
///
/// </file>
/// ----------------------------------------------------------------------------------------
import { Injectable } from '@angular/core';
import { Router, CanActivate,CanActivateChild } from '@angular/router';
import { HydUser } from '../../models/user';

@Injectable()
export class LoggedInGuard implements CanActivate,CanActivateChild {
  constructor(
    private router: Router,
    private hydUser: HydUser
  ) 
  {    
  }

  canActivate() {
    if (this.hydUser.isLoggedIn) {
      return true;
    }
    else {
        this.router.navigate(['/login']);
    }
  }

  canActivateChild () {
    if (this.hydUser.isLoggedIn) {
      return true;
    }
    else {
      this.router.navigate(['/login']);
    }
  }
}


// WEBPACK FOOTER //
// C:/WS/Fusion/FusionDashboard/src/app/authentication/login/loggedin-guard.service.ts